<template>
	<div style="cursor: pointer;">
		<span v-if='liveListing?.priceInfoHistories?.length > 0' @click="showModal = true" class="cursor-pointer">
			{{liveListing?.priceState}}
		</span>
		<span v-else>
			<span class="m-2">0</span>
		</span>
		<b-modal v-model="showModal" @hide="showModal = false" size="small" hide-header-close hide-footer>
			<!--Simulating a table because, because an actual table is not rendered-->
			<div class="price-history-grid">
				<!-- Header Row -->
				<div class="header">ID</div>
				<div class="header">Datum</div>
				<div class="header">Seller</div>
				<div class="header">FBA</div>
				<div class="header">PS</div>

				<!-- Data Rows -->
				<template v-for="(pri, index) in liveListing.priceInfoHistories" :key="index">
					<div>{{ pri.historyId }}</div>
					<div>{{ pri.lastUpdateTime }}</div>
					<div>{{ pri.merchantPrice != null ? Number(pri.merchantPrice).toFixed(2) : '—' }}</div>
					<div>{{ pri.marketPrice != null ? Number(pri.marketPrice).toFixed(2) : '—' }}</div>
					<div>{{ pri.priceState }}</div>
				</template>
			</div>
		</b-modal>
	</div>
</template>
<script>

export default {
  props : {
    liveListing: {
      type : Object,
      required: true,
    }
  },
  data() {
		return {
			showModal: false
		}
	},
}
</script>
<style scoped>
.price-history-grid {
	display: grid;
	grid-template-columns: repeat(5, 1fr); /* 5 columns */
	gap: 4px;
	font-size: 0.85rem;
}

.price-history-grid .header {
	font-weight: bold;
	background: #f0f0f0;
	padding: 4px;
	border-bottom: 1px solid #ccc;
}

.price-history-grid > div {
	padding: 4px;
	border-bottom: 1px solid #eee;
	overflow-wrap: anywhere;
}
</style>